module.exports = __webpack_public_path__ + "static/media/shell-recharge.c509ef4b.png";